import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Outlet } from 'react-router-dom';
import { Suspense } from "react";

export default function RequiredAuth() {
  const { 
    isLoading, 
    isAuthenticated, 
    loginWithRedirect,
    error 
  } = useAuth0();
  
  const [isInitiating, setIsInitiating] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      if (!isAuthenticated && !isInitiating) {
        setIsInitiating(true);

        // Store current URL to return after login
        const returnTo = window.location.pathname + window.location.search;
        sessionStorage.setItem('auth0_return_to', returnTo);

        loginWithRedirect({
          appState: { returnTo },
          authorizationParams: {
            redirect_uri: window.location.origin + '/login/callback'
          }
        }).catch(err => {
          console.error('Error during Auth0 sign in:', err);
          setIsInitiating(false);
        });
      }

      if (isAuthenticated) {
        setIsInitiating(false);
      }

      if (error) {
        console.error('Auth0 error:', error);
        setIsInitiating(false);
      }
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, error, isInitiating]);

  // Show loading state
  if (isLoading || !isAuthenticated) {
    return (<h3 id='loading-icon'>Authenticating...</h3>);
  }

  return (
    <Suspense fallback={<div>Loading content...</div>}>
      <Outlet />
    </Suspense>
  );
}